import { render, staticRenderFns } from "./ShimmerLoader.vue?vue&type=template&id=5f058970&scoped=true&"
import script from "./ShimmerLoader.vue?vue&type=script&lang=js&"
export * from "./ShimmerLoader.vue?vue&type=script&lang=js&"
import style0 from "./ShimmerLoader.vue?vue&type=style&index=0&id=5f058970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f058970",
  null
  
)

export default component.exports